<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Tarih
    </div>
    <template v-if="dataItem.ddate">
      <div>
        {{ moment(dataItem.ddate).format('DD.MM.YYYY') }}
      </div>
    </template>
    <template v-else>
      Belirtilmedi
    </template>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonateDate',
  components: {
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
